import { useEffect, useState } from "react";

export const useLocalStorage = <T,>(
  key: string,
  setValue: (data: T) => void,
  value: T,
  _loaded?: boolean,
) => {
  const [loaded, setLoaded] = useState(_loaded ? true : false);
  useEffect(() => {
    if (loaded) return;
    let data: T | undefined = undefined;
    try {
      data = JSON.parse(localStorage.getItem(key)!) || undefined;
    } catch (ex) {
      // ignore
    }
    if (data !== undefined) {
      setValue(data);
    }
    setLoaded(true);
  }, [loaded]);
  useEffect(() => {
    if (!loaded) return;
    try {
      if (value === undefined) {
        localStorage.removeItem(key);
      } else {
        localStorage.setItem(key, JSON.stringify(value));
      }
    } catch (ex) {
      console.error(ex);
    }
  }, [value, loaded]);
  return loaded;
};
